import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplets, Activity, Syringe, Eye, Gift } from 'lucide-react';
const services = [{
  icon: <Sparkles className="w-8 h-8" data-id="element-142" />,
  title: 'Permanent Makeup',
  description: 'Eyebrows, Eyeliner & Lip Blush by certified specialists for effortless, long-lasting beauty.'
}, {
  icon: <Droplets className="w-8 h-8" data-id="element-143" />,
  title: 'Skincare Treatments',
  description: 'Custom facials, microneedling, plasma treatments, chemical peels & skin imperfection removal. All facials include dermaplaning.'
}, {
  icon: <Activity className="w-8 h-8" data-id="element-144" />,
  title: 'Body Treatments',
  description: 'Back treatments, full body waxing & laser hair removal for smooth, radiant skin.'
}, {
  icon: <Syringe className="w-8 h-8" data-id="element-145" />,
  title: 'Injectables',
  description: 'Botox, fillers & Sculptra administered by experienced professionals to restore youthful volume.'
}, {
  icon: <Eye className="w-8 h-8" data-id="element-146" />,
  title: 'Lash & Brow Services',
  description: 'Lash extensions, lash lifts, brow & lash tinting to perfectly frame your face.'
}, {
  icon: <Gift className="w-8 h-8" data-id="element-147" />,
  title: 'Gift Certificates',
  description: 'The perfect gift for someone special. Treat your loved ones to a luxurious spa experience.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Services() {
  return <section id="services" className="py-20 md:py-32 bg-brand-gray" data-id="element-148">
      <div className="container mx-auto px-4 md:px-6" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-4" data-id="element-151">
            Our Services
          </h2>
          <p className="text-lg text-brand-charcoal/70 max-w-2xl mx-auto" data-id="element-152">
            Customized Treatments for Every Skin Concern
          </p>
          <div className="w-16 h-1 bg-brand-teal mx-auto mt-6" data-id="element-153"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-154">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl hover:shadow-brand-teal/10 border border-transparent hover:border-brand-teal/30 transition-all duration-300 group flex flex-col h-full" data-id="element-155">
              <div className="w-16 h-16 bg-brand-blush rounded-full flex items-center justify-center text-brand-teal mb-6 group-hover:bg-brand-teal group-hover:text-white transition-colors duration-300" data-id="element-156">
                {service.icon}
              </div>
              <h3 className="text-xl font-heading font-semibold text-brand-charcoal mb-3" data-id="element-157">
                {service.title}
              </h3>
              <p className="text-brand-charcoal/70 leading-relaxed flex-grow" data-id="element-158">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>

        <div className="mt-16 text-center" data-id="element-159">
          <a href="#contact" className="inline-block bg-transparent border-2 border-brand-charcoal text-brand-charcoal px-8 py-4 rounded-sm font-semibold hover:bg-brand-charcoal hover:text-white transition-colors" data-id="element-160">
            View All Services & Pricing
          </a>
        </div>
      </div>
    </section>;
}